import { MapPin } from "lucide-react";
import { cn } from "../../lib/utils";

const panel =
    "absolute left-0 right-0 top-full z-50 mt-2 overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg";

// ~5 visible rows; taller address rows (main + secondary) vs single-line block/lot.
const ADDRESS_SCROLL = "max-h-[16.25rem] overflow-y-auto";
const BLOCK_LOT_SCROLL = "max-h-[11.25rem] overflow-y-auto";

// Google address predictions dropdown (positioned against the nearest `relative` ancestor).
export function PredictionList({ search, className, id }) {
    if (!search.showList) return null;
    return (<div className={cn(panel, "text-left", className)}>
      <ul role="listbox" id={id} className={ADDRESS_SCROLL}>
        {search.predictions.map((prediction, index) => (<li key={prediction.place_id || prediction.description} role="option" aria-selected={index === search.highlighted} onMouseDown={(event) => {
                  // mousedown fires before the input blurs, so the pick is not lost.
                  event.preventDefault();
                  search.selectPrediction(prediction);
              }} onMouseEnter={() => search.setHighlighted(index)} className={cn("flex cursor-pointer items-start gap-2.5 rounded-md px-3 py-2 text-sm", index === search.highlighted && "bg-secondary")}>
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground"/>
            <span className="min-w-0">
              <span className="block truncate font-semibold">{search.mainText(prediction)}</span>
              {search.secondaryText(prediction) && (<span className="block truncate text-xs text-muted-foreground">
                  {search.secondaryText(prediction)}
                </span>)}
            </span>
          </li>))}
      </ul>
      <p aria-hidden="true" className="px-3 pb-1 pt-2 text-right text-[10px] text-muted-foreground">
        powered by Google
      </p>
    </div>);
}

// Addresses found for a block / lot.
export function BlockLotResults({ search, className }) {
    if (!search.showList) return null;
    return (<div className={cn(panel, "text-left", className)}>
      {search.loading ? (<p className="px-3 py-2 text-sm text-muted-foreground">Loading addresses…</p>) : search.addresses.length === 0 ? (<p className="px-3 py-2 text-sm text-muted-foreground">No addresses found</p>) : (<ul className={BLOCK_LOT_SCROLL}>
          {search.addresses.map((entry) => (<li key={entry.address}>
              <button type="button" onClick={() => search.selectAddress(entry)} className="block w-full rounded-md px-3 py-2 text-left text-sm hover:bg-secondary">
                {entry.address}
              </button>
            </li>))}
        </ul>)}
    </div>);
}
